import { ChainId } from "configs/web3";
import { TokenAddressMap } from "store/tokens/types";

export const getTokenFromTokenKey = (allTokensList: TokenAddressMap | null, network?: ChainId, publicCode?: string) => {
  const currency =
    network && publicCode && allTokensList && allTokensList[network] && allTokensList[network][publicCode];

  return currency ? currency : null;
};
